var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.22 19.055h0l-.009.009c-.411.434-1.108.447-1.564-.009a1.122 1.122 0 010-1.605h0L24.11 1.986h0l.009-.008c.411-.435 1.108-.447 1.564.008.45.45.45 1.155 0 1.606h0L10.22 19.055z",
    fill: "#E1E1E1",
    stroke: "#fff",
    strokeWidth: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.964 24.914h.35V13.29c0-.594.481-1.059 1.055-1.063h.008c.577 0 1.063.466 1.063 1.063v12.688c0 .29-.11.555-.31.754-.199.199-.463.31-.753.31H1.413c-.29 0-.554-.111-.753-.31a1.052 1.052 0 01-.31-.754V2.014C.35 1.417.836.95 1.413.95h12.718c.56 0 1.03.477 1.034 1.056-.026.616-.5 1.07-1.063 1.07H2.476V24.914H23.964z",
    fill: "#E1E1E1",
    stroke: "#fff",
    strokeWidth: 0.7
  })));
}
export default SvgEdit;